var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67333 9.99378C3.1056 11.2207 3.92489 12.2739 5.00777 12.9947C6.09065 13.7155 7.37846 14.0648 8.67714 13.9901C9.97583 13.9153 11.2151 13.4206 12.2081 12.5803C13.2011 11.74 13.8942 10.5998 14.1828 9.33136C14.4715 8.06295 14.3401 6.73509 13.8084 5.54785C13.2768 4.36061 12.3737 3.37831 11.2352 2.74896C10.0968 2.1196 8.7846 1.87729 7.49645 2.05853C6.2083 2.23976 5.01394 2.83473 4.09333 3.75378L1 6.66045M1 2.66043V6.66043H5",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5V8L10.6667 9.33333",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillHistory);
export default __webpack_public_path__ + "static/media/fill-history.66f01bffe8fb8797f5aa9d3ba5caf7d3.svg";
export { ForwardRef as ReactComponent };